import React, { useState } from 'react';
import "./DauTu.css";

function DauTu () {
     const [showIndustrialZoneModal, setShowIndustrialZoneModal] =
    useState(false);

  const [industrialZoneStep, setIndustrialZoneStep] = useState(1);

  const openIndustrialZoneModal = () => {
    setShowIndustrialZoneModal(true);
    setIndustrialZoneStep(1);
  };

  const closeIndustrialZoneModal = () => {
    setShowIndustrialZoneModal(false);
  };

  const nextIndustrialZoneStep = () => {
    if (industrialZoneStep < 2) {
      setIndustrialZoneStep(industrialZoneStep + 1);
    }
  };

  const prevIndustrialZoneStep = () => {
    if (industrialZoneStep > 1) {
      setIndustrialZoneStep(industrialZoneStep - 1);
    }
  };
   
        return (
   <div className="tong-quan-wrapper">

        {/* breadcrumb */}
        <div className="tong-quan-breadcrumb">
            <span className="tong-quan-breadcrumb-item">Trang chủ</span>
            <span className="tong-quan-breadcrumb-arrow">›</span>

            <span className="tong-quan-breadcrumb-item">Đầu tư</span>
            <span className="tong-quan-breadcrumb-arrow">›</span>

            <span className="tong-quan-breadcrumb-active">Tổng quan</span>
        </div>

        {/* heading */}
        <div className="tong-quan-heading-row">

            <div className="tong-quan-heading-left">
                <h2 className="tong-quan-heading-title">Tổng quan đầu tư</h2>
            </div>

            <div className="tong-quan-heading-right">

                <button className="tong-quan-report-btn">
                    <i className="fa-regular fa-file-lines tong-quan-report-icon"></i>
                    Báo cáo tổng hợp
                </button>

                <button className="tong-quan-add-btn" onClick={openIndustrialZoneModal}>
                    <i className="fa-solid fa-plus tong-quan-add-icon"></i>
                    Thêm dự án đầu tư
                </button>

            </div>

        </div>

        {/* statistic cards */}
        <div className="tong-quan-card-row">

            {/* card 1 */}
            <div className="tong-quan-card-item">

                <div className="tong-quan-card-top">

                    <div className="tong-quan-card-icon-box tong-quan-card-blue">
                        <i className="fa-regular fa-folder-open tong-quan-card-icon"></i>
                    </div>

                    <div className="tong-quan-card-content">

                        <p className="tong-quan-card-label">
                            Tổng số dự án
                        </p>

                        <div className="tong-quan-card-number-row">
                            <h3 className="tong-quan-card-number">
                                128
                            </h3>
                        </div>

                        <p className="tong-quan-card-growth">
                            ▲ 12 
                            <span className='project'>dự án so với kỳ trước</span>
                        </p>

                    </div>

                </div>

            </div>

            {/* card 2 */}
            <div className="tong-quan-card-item">

                <div className="tong-quan-card-top">

                    <div className="tong-quan-card-icon-box tong-quan-card-green">
                        <i className="fa-regular fa-money-bill-1 tong-quan-card-icon"></i>
                    </div>

                    <div className="tong-quan-card-content">

                        <p className="tong-quan-card-label">
                            Tổng vốn đăng ký
                        </p>

                        <div className="tong-quan-card-number-row">
                            <h3 className="tong-quan-card-number">
                                80.000
                            </h3>

                            <span className="tong-quan-card-unit">
                                tỷ đồng
                            </span>
                        </div>

                        <p className="tong-quan-card-growth">
                            ▲ 5.230 
                            <span className='project'>tỷ đồng so với kỳ trước</span>
                        </p>

                    </div>

                </div>

            </div>

            {/* card 3 */}
            <div className="tong-quan-card-item">

                <div className="tong-quan-card-top">

                    <div className="tong-quan-card-icon-box tong-quan-card-purple">
                        <i className="fa-regular fa-envelope-open tong-quan-card-icon"></i>
                    </div>

                    <div className="tong-quan-card-content">

                        <p className="tong-quan-card-label">
                            Vốn thực hiện lũy kế
                        </p>

                        <div className="tong-quan-card-number-row">
                            <h3 className="tong-quan-card-number">
                                32.450
                            </h3>

                            <span className="tong-quan-card-unit">
                                tỷ đồng
                            </span>
                        </div>

                        <p className="tong-quan-card-growth">
                            ▲ 3.120 
                            <span className='project'>tỷ đồng so với kỳ trước</span>
                        </p>

                    </div>

                </div>

            </div>

            {/* card 4 */}
            <div className="tong-quan-card-item">

                <div className="tong-quan-card-top">

                    <div className="tong-quan-card-icon-box tong-quan-card-orange">
                        <i className="fa-regular fa-building tong-quan-card-icon"></i>
                    </div>

                    <div className="tong-quan-card-content">

                        <p className="tong-quan-card-label">
                            Tỷ lệ lấp đầy KCN
                        </p>

                        <div className="tong-quan-card-number-row">
                            <h3 className="tong-quan-card-number">
                                68,5%
                            </h3>
                        </div>

                        <p className="tong-quan-card-growth">
                            ▲ 2,3% 
                            <span className='project'>so với kỳ trước</span>
                        </p>

                    </div>

                </div>

            </div>

        </div>

        {/* chart section */}
        <div className="tong-quan-chart-layout">

            {/* left chart */}
            <div className="tong-quan-chart-bar-card">

                <div className="tong-quan-chart-header">

                    <h3 className="tong-quan-chart-title">
                        Số dự án đầu tư theo năm
                    </h3>

                    <button className="tong-quan-chart-dropdown">
                        5 năm gần nhất
                        <i className="fa-solid fa-angle-down tong-quan-chart-dropdown-icon"></i>
                    </button>

                </div>

                {/* legends */}
                <div className="tong-quan-chart-legend-row">

                    <div className="tong-quan-chart-legend-item">
                        <span className="tong-quan-chart-legend-blue"></span>
                        <span className="tong-quan-chart-legend-text">
                            Số dự án
                        </span>
                    </div>

                    <div className="tong-quan-chart-legend-item">
                        <span className="tong-quan-chart-legend-green"></span>
                        <span className="tong-quan-chart-legend-text">
                            Vốn đăng ký (tỷ đồng)
                        </span>
                    </div>

                </div>

                {/* chart */}
                <div className="tong-quan-bar-chart-wrapper">

                    {/* left label */}
                    <div className="tong-quan-chart-left-title">
                        Số dự án
                    </div>

                    {/* right label */}
                    <div className="tong-quan-chart-right-title">
                        Vốn đăng ký (tỷ đồng)
                    </div>

                    {/* horizontal lines */}
                    <div className="tong-quan-grid-line tong-quan-grid-line-1"></div>
                    <div className="tong-quan-grid-line tong-quan-grid-line-2"></div>
                    <div className="tong-quan-grid-line tong-quan-grid-line-3"></div>
                    <div className="tong-quan-grid-line tong-quan-grid-line-4"></div>

                    {/* y left */}
                    <div className="tong-quan-y-left">
                        <span>0</span>
                        <span>10</span>
                        <span>20</span>
                        <span>30</span>
                        <span>40</span>
                    </div>

                    {/* y right */}
                    <div className="tong-quan-y-right">
                        <span>0</span>
                        <span>10.000</span>
                        <span>20.000</span>
                        <span>30.000</span>
                        <span>40.000</span>
                    </div>

                    {/* bars */}
                    <div className="tong-quan-chart-bars">

                        <div className="tong-quan-bar-group">

                            <div className="tong-quan-bar-item">

                                <div className="tong-quan-bar-number">
                                    24
                                </div>

                                <div className="tong-quan-bar tong-quan-bar-h-24"></div>

                            </div>

                            {/* <div className="tong-quan-line-point tong-quan-line-point-1">
                                <span>24</span>
                            </div> */}

                            <div className="tong-quan-year-label">
                                2022
                            </div>

                        </div>

                        <div className="tong-quan-bar-group">

                            <div className="tong-quan-bar-item">

                                <div className="tong-quan-bar-number">
                                    28
                                </div>

                                <div className="tong-quan-bar tong-quan-bar-h-28"></div>

                            </div>

                            {/* <div className="tong-quan-line-point tong-quan-line-point-2">
                                <span>28</span>
                            </div> */}

                            <div className="tong-quan-year-label">
                                2023
                            </div>

                        </div>

                        <div className="tong-quan-bar-group">

                            <div className="tong-quan-bar-item">

                                <div className="tong-quan-bar-number">
                                    30
                                </div>

                                <div className="tong-quan-bar tong-quan-bar-h-30"></div>

                            </div>

                            {/* <div className="tong-quan-line-point tong-quan-line-point-3">
                                <span>30</span>
                            </div> */}

                            <div className="tong-quan-year-label">
                                2024
                            </div>

                        </div>

                        <div className="tong-quan-bar-group">

                            <div className="tong-quan-bar-item">

                                <div className="tong-quan-bar-number">
                                    25
                                </div>

                                <div className="tong-quan-bar tong-quan-bar-h-25"></div>

                            </div>

                            {/* <div className="tong-quan-line-point tong-quan-line-point-4">
                                <span>25</span>
                            </div> */}

                            <div className="tong-quan-year-label">
                                2025
                            </div>

                        </div>

                        <div className="tong-quan-bar-group">

                            <div className="tong-quan-bar-item">

                                <div className="tong-quan-bar-number">
                                    21
                                </div>

                                <div className="tong-quan-bar tong-quan-bar-h-21"></div>

                            </div>

                            {/* <div className="tong-quan-line-point tong-quan-line-point-5">
                                <span>21</span>
                            </div> */}

                            <div className="tong-quan-year-label">
                                2026
                            </div>

                        </div>

                        {/* line */}
                        <div className="tong-quan-chart-line">
                            <div className="tong-quan-line-segment tong-quan-line-segment-1 chart-dot-1">
                               
                            </div>
                            <div className="tong-quan-line-segment tong-quan-line-segment-2"></div>
                            <div className="tong-quan-line-segment tong-quan-line-segment-3"></div>
                            <div className="tong-quan-line-segment tong-quan-line-segment-4"></div>
                        </div>

                    </div>

                </div>

            </div>

            {/* right chart column */}
            <div className="tong-quan-chart-right-column">

                {/* pie 1 */}
                <div className="tong-quan-pie-card">

                    <h3 className="tong-quan-pie-title">
                        Cơ cấu vốn đầu tư
                    </h3>

                    <div className="tong-quan-pie-content circle-left">

                        <div className="tong-quan-pie-circle tong-quan-pie-circle-first">

                            <div className="tong-quan-pie-center">
                                <h4>80.000</h4>
                                <span>tỷ đồng</span>
                            </div>

                        </div>

                        <div className="tong-quan-pie-legend">

                            <div className="tong-quan-pie-legend-item">
                                <span className="tong-quan-pie-blue"></span>

                                <div>
                                    <h5>Trong nước</h5>
                                    <p>35.000 tỷ (43,75%)</p>
                                </div>
                            </div>

                            <div className="tong-quan-pie-legend-item">
                                <span className="tong-quan-pie-green"></span>

                                <div>
                                    <h5>Nước ngoài (FDI)</h5>
                                    <p>45.000 tỷ (56,25%)</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                {/* pie 2 */}
                <div className="tong-quan-pie-card">

                    <div className="tong-quan-chart-header">

                        <h3 className="tong-quan-pie-title">
                            Dự án theo trạng thái
                        </h3>

                        <button className="tong-quan-chart-dropdown">
                            Tất cả
                            <i className="fa-solid fa-angle-down tong-quan-chart-dropdown-icon"></i>
                        </button>

                    </div>

                    <div className="tong-quan-pie-content">

                        <div className="tong-quan-pie-circle tong-quan-pie-circle-second">

                            <div className="tong-quan-pie-center">
                                <h4>128</h4>
                                <span>dự án</span>
                            </div>

                        </div>

                        <div className="tong-quan-pie-legend">

                            <div className="tong-quan-pie-legend-item">
                                <span className="tong-quan-status-blue"></span>

                                <div>
                                    <h5>Đang hoạt động</h5>
                                    <p>85 dự án (66,41%)</p>
                                </div>
                            </div>

                            <div className="tong-quan-pie-legend-item">
                                <span className="tong-quan-status-green"></span>

                                <div>
                                    <h5>Đang triển khai</h5>
                                    <p>24 dự án (18,75%)</p>
                                </div>
                            </div>

                            <div className="tong-quan-pie-legend-item">
                                <span className="tong-quan-status-orange"></span>

                                <div>
                                    <h5>Tạm dừng</h5>
                                    <p>12 dự án (9,38%)</p>
                                </div>
                            </div>

                            <div className="tong-quan-pie-legend-item">
                                <span className="tong-quan-status-pink"></span>

                                <div>
                                    <h5>Đã chấm dứt</h5>
                                    <p>7 dự án (5,46%)</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        {/* table */}
        <div className="tong-quan-table-card">

            <div className="tong-quan-table-header">

                <h3 className="tong-quan-table-title">
                    Danh sách dự án đầu tư
                </h3>

                <div className="tong-quan-table-action">

                    <button className="tong-quan-table-btn">
                        Tất cả khu công nghiệp
                        <i className="fa-solid fa-angle-down tong-quan-table-btn-icon"></i>
                    </button>

                    <button className="tong-quan-table-btn">
                        <i className="fa-regular fa-calendar icon-share-show"></i>
                        Thời gian đăng ký
                        <i className="fa-solid fa-angle-down tong-quan-table-btn-icon"></i>
                    </button>

                    <button className="tong-quan-table-filter-btn">
                        <i className="fa-solid fa-filter icon-share-show"></i>
                        Bộ lọc
                    </button>

                </div>

            </div>

            <div className="tong-quan-table-responsive">

                <table className="tong-quan-table">

                    <thead>

                        <tr>
                            <th>STT</th>
                            <th>Tên dự án</th>
                            <th>Nhà đầu tư</th>
                            <th>KCN/Địa điểm</th>
                            <th>Vốn đăng ký (tỷ đồng)</th>
                            <th>Vốn thực hiện (tỷ đồng)</th>
                            <th>Tỷ lệ thực hiện</th>
                            <th>Trạng thái</th>
                            <th>Thao tác</th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr>
                            <td>1</td>
                            <td>Nhà máy may An Giang</td>
                            <td>Công ty TNHH An Giang Garment</td>
                            <td>KCN Bình Hòa</td>
                            <td>500</td>
                            <td>320</td>
                            <td>64,00%</td>
                            <td>
                                <span className="tong-quan-status-badge tong-quan-status-active">
                                    Đang hoạt động
                                </span>
                            </td>
                            <td>
                                <div className="tong-quan-action-group">
                                    <i className="fa-regular fa-eye"></i>
                                    <i className="fa-regular fa-pen-to-square"></i>
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>Nhà máy chế biến thủy sản AG</td>
                            <td>Công ty CP Thủy sản AG</td>
                            <td>KCN Bình Hòa</td>
                            <td>800</td>
                            <td>450</td>
                            <td>56,25%</td>
                            <td>
                                <span className="tong-quan-status-badge tong-quan-status-process">
                                    Đang triển khai
                                </span>
                            </td>
                            <td>
                                <div className="tong-quan-action-group">
                                    <i className="fa-regular fa-eye"></i>
                                    <i className="fa-regular fa-pen-to-square"></i>
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>Nhà máy sản xuất bao bì</td>
                            <td>Công ty TNHH Bao bì An Phát</td>
                            <td>KCN Vĩnh Thạnh</td>
                            <td>300</td>
                            <td>120</td>
                            <td>40,00%</td>
                            <td>
                                <span className="tong-quan-status-badge tong-quan-status-stop">
                                    Tạm dừng
                                </span>
                            </td>
                            <td>
                                <div className="tong-quan-action-group">
                                    <i className="fa-regular fa-eye"></i>
                                    <i className="fa-regular fa-pen-to-square"></i>
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>Nhà máy điện mặt trời AG Solar</td>
                            <td>Công ty CP Năng lượng AG</td>
                            <td>KCN Tân Trung</td>
                            <td>1.200</td>
                            <td>900</td>
                            <td>75,00%</td>
                            <td>
                                <span className="tong-quan-status-badge tong-quan-status-active">
                                    Đang hoạt động
                                </span>
                            </td>
                            <td>
                                <div className="tong-quan-action-group">
                                    <i className="fa-regular fa-eye"></i>
                                    <i className="fa-regular fa-pen-to-square"></i>
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>Dự án kho bãi và logistics</td>
                            <td>Công ty TNHH Logistics Mekong</td>
                            <td>KCN Bình Hòa</td>
                            <td>400</td>
                            <td>50</td>
                            <td>12,50%</td>
                            <td>
                                <span className="tong-quan-status-badge tong-quan-status-process">
                                    Đang triển khai
                                </span>
                            </td>
                            <td>
                                <div className="tong-quan-action-group">
                                    <i className="fa-regular fa-eye"></i>
                                    <i className="fa-regular fa-pen-to-square"></i>
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </td>
                        </tr>

                    </tbody>

                </table>

            </div>

            <div className="tong-quan-pagination-row">

                <div className="tong-quan-pagination-left">
                    Hiển thị 1 - 5 trong tổng số 128 dự án
                </div>

                <div className="tong-quan-pagination-right">

                    <button className="tong-quan-page-size">
                        5 / trang
                        <i className="fa-solid fa-angle-down"></i>
                    </button>

                    <div className="tong-quan-page-group">

                        <button className="tong-quan-page-arrow">
                            <i className="fa-solid fa-angle-left"></i>
                        </button>

                        <button className="tong-quan-page-item tong-quan-page-active">
                            1
                        </button>

                        <button className="tong-quan-page-item">
                            2
                        </button>

                        <button className="tong-quan-page-item">
                            3
                        </button>

                        <span className="tong-quan-page-dot">...</span>

                        <button className="tong-quan-page-item">
                            26
                        </button>

                        <button className="tong-quan-page-arrow">
                            <i className="fa-solid fa-angle-right"></i>
                        </button>

                    </div>

                </div>

            </div>

        </div>

























            <div>
                   {/* Nội dung Modal */}

        
     {/* Overlay hiển thị ảnh 2 và 3 */}
      {showIndustrialZoneModal && (
        <div className="investment-project-overlay">
          <div className="investment-project-container">
            {/* Header */}
            <div className="investment-project-top">
              <div>
                <div className="investment-project-breadcrumb">
                  <span>Trang chủ</span>
                  <i className="fa-solid fa-chevron-right"></i>

                  <span>Đầu tư</span>
                  <i className="fa-solid fa-chevron-right"></i>

                  <span>Dự án đầu tư</span>
                  <i className="fa-solid fa-chevron-right"></i>

                  <span>Thêm dự án</span>
                </div>

                <h2 className="investment-project-heading">
                  Thêm dự án đầu tư
                </h2>
              </div>

              <button className="investment-project-guide-btn">
                <i className="fa-regular fa-circle-question icon-huong-dan"></i>
                Hướng dẫn
              </button>
            </div>

            {/* Step */}
            <div className="investment-project-step-wrapper">
              <div className="investment-project-step-item">
                <div
                  className={`investment-project-step-number ${
                    industrialZoneStep >= 1
                      ? "investment-project-step-active"
                      : ""
                  }`}
                >
                  {industrialZoneStep > 1 ? (
                    <i className="fa-solid fa-check"></i>
                  ) : (
                    "1"
                  )}
                </div>

                <span className="investment-project-step-text">
                  Thông tin chung
                </span>
                <i className="fa-solid fa-check check-list-icon"></i>
              </div>

              <div className="investment-project-step-line"></div>

              <div className="investment-project-step-item">
                <div
                  className={`investment-project-step-number ${
                    industrialZoneStep >= 2
                      ? "investment-project-step-active"
                      : ""
                  }`}
                >
                  {industrialZoneStep > 2 ? (
                    <i className="fa-solid fa-check"></i>
                    
                  ) : (
                    <i className="fa-solid fa-check"></i>
                  )}
                </div>

                <span className="investment-project-step-text">
                  Thông tin tài chính
                </span>
                <i className="fa-solid fa-check check-list-icon"></i>
              </div>

              <div className="investment-project-step-line"></div>

              <div className="investment-project-step-item">
                <div
                  className={`investment-project-step-number ${
                    industrialZoneStep >= 3
                      ? "investment-project-step-active"
                      : ""
                  }`}
                >
                  3
                </div>

                <span className="investment-project-step-text">
                  Hồ sơ, tài liệu
                </span>
              </div>

              <div className="investment-project-step-line"></div>

              <div className="investment-project-step-item">
                <div className="investment-project-step-number">4</div>

                <span className="investment-project-step-text">Xác nhận</span>
              </div>
            </div>

            {/* STEP 1 - ẢNH 2 */}
            {industrialZoneStep === 1 && (
              <>
                <div className="investment-project-form-grid">
                  {/* LEFT */}
                  <div className="investment-project-card">
                    <h3 className="investment-project-card-title">
                      Thông tin dự án
                    </h3>

                    <div className="investment-project-form-group">
                      <label className="investment-project-label">
                        Tên dự án <span className='text-danger ml-2'>*</span>
                      </label>

                      <input
                        type="text"
                        className="investment-project-input"
                        placeholder="Nhập tên dự án"
                      />
                    </div>

                    <div className="investment-project-form-group">
                      <label className="investment-project-label">
                        Nhà đầu tư <span className='text-danger ml-2'>*</span>
                      </label>

                      <div className="investment-project-select-wrapper">
                        <select className="investment-project-select">
                          <option>Chọn nhà đầu tư</option>
                        </select>

                        <button className="investment-project-add-small-btn">
                          <i className="fa-solid fa-plus"></i>
                          Thêm mới
                        </button>
                      </div>
                    </div>

                    <div className="investment-project-form-group">
                      <label className="investment-project-label">
                        Khu công nghiệp/Địa điểm <span className='text-danger ml-2'>*</span>
                      </label>

                      <select className="investment-project-select">
                        <option>Chọn khu công nghiệp/địa điểm</option>
                      </select>
                    </div>

                    <div className="investment-project-form-group">
                      <label className="investment-project-label">
                        Lĩnh vực đầu tư <span className='text-danger ml-2'>*</span>
                      </label>

                      <select className="investment-project-select">
                        <option>Chọn lĩnh vực đầu tư</option>
                      </select>
                    </div>

                    <div className="investment-project-double-grid">
                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Quy mô dự án <span className='text-danger ml-2'>*</span>
                        </label>

                        <div className="investment-project-unit-wrapper">
                          <input
                            type="text"
                            className="investment-project-input-note"
                            placeholder="Nhập quy mô dự án"
                          />
                          <span className="investment-project-unit-note">m²</span>
                          <select className="scale-project">
                            <option></option>
                          </select>
                        </div>
                      </div>

                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Công suất thiết kế
                        </label>

                        <div className="investment-project-unit-wrapper">
                          <input
                            type="text"
                            className="investment-project-input-design"
                            placeholder="Nhập công suất thiết kế"
                          />

                          <span className="investment-project-unit-year">
                            Đơn vị/
                            <br/>
                            năm
                          </span>
                          <select className='unit-year'>
                            <option></option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="investment-project-double-grid">
                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Số quyết định chủ trương đầu tư <span className='text-danger ml-2'>*</span>
                        </label>

                        <input
                          type="text"
                          className="investment-project-input"
                          placeholder="Nhập số quyết định"
                        />
                      </div>

                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Ngày cấp <span className='text-danger ml-2'>*</span>
                        </label>

                        <input
                          type="date"
                          className="investment-project-input"
                        />
                      </div>
                    </div>

                    <div className="investment-project-double-grid">
                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Cơ quan cấp <span className='text-danger ml-2'>*</span>
                        </label>

                        <select className="investment-project-select">
                          <option>Chọn cơ quan cấp</option>
                        </select>
                      </div>

                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Giấy chứng nhận đăng ký đầu tư
                        </label>

                        <input
                          type="text"
                          className="investment-project-input"
                          placeholder="Nhập số giấy chứng nhận"
                        />
                      </div>
                    </div>

                    <div className="investment-project-double-grid">
                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Ngày cấp GCN ĐKTĐ
                        </label>

                        <input
                          type="date"
                          className="investment-project-input"
                        />
                      </div>

                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Dự án thuộc ngành nghề
                        </label>

                        <select className="investment-project-select">
                          <option>Chọn ngành nghề</option>
                        </select>
                      </div>
                    </div>

                    <div className="investment-project-form-group">
                      <label className="investment-project-label">
                        Mục tiêu dự án <span className='text-danger ml-2'>*</span>
                      </label>

                      <textarea
                        className="investment-project-textarea"
                        placeholder="Nhập mục tiêu dự án"
                      ></textarea>

                      <div className="investment-project-text-count">
                        0/1000
                      </div>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="investment-project-right-wrapper">
                    <div className="investment-project-card">
                      <h3 className="investment-project-card-title">
                        Thông tin địa điểm thực hiện dự án
                      </h3>

                      <div className="investment-project-double-grid">
                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Khu công nghiệp <span className='text-danger ml-2'>*</span>
                          </label>

                          <select className="investment-project-select">
                            <option>Chọn khu công nghiệp</option>
                          </select>
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Lô đất/Số thửa (nếu có)
                          </label>

                          <input
                            type="text"
                            className="investment-project-input"
                            placeholder="Nhập lô đất/số thửa"
                          />
                        </div>
                      </div>

                      <div className="investment-project-form-group">
                        <label className="investment-project-label">
                          Địa chỉ <span className='text-danger ml-2'>*</span>
                        </label>

                        <input
                          type="text"
                          className="investment-project-input"
                          placeholder="Nhập địa chỉ"
                        />
                      </div>

                      <div className="investment-project-triple-grid">
                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Xã/Phường <span className='text-danger ml-2'>*</span>
                          </label>

                          <select className="investment-project-select">
                            <option>Chọn xã/phường</option>
                          </select>
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label-city">
                            Huyện/Thị xã/Thành phố <span className='text-danger ml-2'>*</span>
                          </label>

                          <select className="investment-project-select-quan-huyen">
                            <option>
                              Chọn huyện/thị xã/thành phố
                            </option>
                          </select>
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Tỉnh/Thành phố <span className='text-danger ml-2'>*</span>
                          </label>

                          <select className="investment-project-select-an-giang">
                            <option>An Giang</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="investment-project-card">
                      <h3 className="investment-project-card-title">
                        Tiến độ thực hiện dự án
                      </h3>

                      <div className="investment-project-double-grid">
                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Ngày khởi công dự kiến <span className='text-danger ml-2'>*</span>
                          </label>

                          <input
                            type="date"
                            className="investment-project-input"
                          />
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Ngày hoàn thành dự kiến <span className='text-danger ml-2'>*</span>
                          </label>

                          <input
                            type="date"
                            className="investment-project-input"
                          />
                        </div>
                      </div>

                      <div className="investment-project-double-grid">
                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Thời hạn hoạt động của dự án <span className='text-danger ml-2'>*</span>
                          </label>

                          <div className="investment-project-unit-wrapper">
                            <input
                              type="text"
                              className="investment-project-input"
                              placeholder="Nhập số năm"
                            />

                            <span className="investment-project-unit">
                              Năm
                            </span>
                          </div>
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Tiến độ hiện tại <span className='text-danger ml-2'>*</span>
                          </label>

                          <select className="investment-project-select">
                            <option>Chọn tiến độ</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="investment-project-card">
                      <h3 className="investment-project-card-title">
                        Thông tin liên hệ của dự án
                      </h3>

                      <div className="investment-project-double-grid">
                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Người liên hệ <span className='text-danger ml-2'>*</span>
                          </label>

                          <input
                            type="text"
                            className="investment-project-input"
                            placeholder="Nhập họ và tên"
                          />
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Chức vụ
                          </label>

                          <input
                            type="text"
                            className="investment-project-input"
                            placeholder="Nhập chức vụ"
                          />
                        </div>
                      </div>

                      <div className="investment-project-double-grid">
                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Số điện thoại *
                          </label>

                          <input
                            type="text"
                            className="investment-project-input"
                            placeholder="Nhập số điện thoại"
                          />
                        </div>

                        <div className="investment-project-form-group">
                          <label className="investment-project-label">
                            Email
                          </label>

                          <input
                            type="email"
                            className="investment-project-input"
                            placeholder="Nhập email"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* FOOTER */}
                <div className="investment-project-footer">
                  <button
                    className="investment-project-back-btn"
                    onClick={closeIndustrialZoneModal}
                  >
                    <i className="fa-solid fa-arrow-left icon-share-show"></i>
                    Quay lại
                  </button>

                  <div className="investment-project-footer-right">
                    <button
                      className="investment-project-cancel-btn"
                      onClick={closeIndustrialZoneModal}
                    >
                      Hủy
                    </button>

                    <button className="investment-project-save-btn">
                      <i className="fa-regular fa-floppy-disk icon-share-show"></i>
                      Lưu tạm
                    </button>

                    <button
                      className="investment-project-next-btn "
                      onClick={nextIndustrialZoneStep}
                    >
                      Tiếp tục
                      <i className="fa-solid fa-arrow-right icon-next"></i>
                    </button>
                  </div>
                </div>
              </>
            )}

            {/* STEP 3 - ẢNH 3 */}
            {industrialZoneStep === 2 && (
              <>
                <div className="investment-document-grid">
                  {/* LEFT */}
                  <div className="investment-project-card">
                    <h3 className="investment-project-card-title">
                      Hồ sơ, tài liệu dự án (bắt buộc)
                    </h3>

                    <table className="investment-document-table">
                      <thead>
                        <tr>
                          <th>Tên tài liệu</th>
                          <th>Mô tả</th>
                          <th>File đính kèm</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Văn bản đề nghị thực hiện dự án</td>
                          <td>Theo mẫu quy định</td>
                          <td>
                           <div className='file-pdf-upload'>
                            <di className='file-warper'>
                             <i className="fa-regular fa-file-pdf icon-pdff"></i>
                            de-nghi-du-an.pdf
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                            </td>
                        </tr>

                        <tr>
                          <td>Báo cáo đề xuất chủ trương đầu tư</td>
                          <td>Báo cáo chi tiết dự án</td>
                          <td>
                            <div className='file-pdf-upload'>
                            <di className='file-warper'>
                             <i className="fa-regular fa-file-pdf icon-pdff"></i>
                            bao-cao-de-xuat.pdf
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                            </td>
                        </tr>

                        <tr>
                          <td>Quyết định chủ trương đầu tư</td>
                          <td>Quyết định của cơ quan có thẩm quyền</td>
                          <td>
                            <div className='file-pdf-upload'>
                            <di className='file-warper'>
                             <i className="fa-regular fa-file-pdf icon-pdff"></i>
                            qd-chu-truong.pdf
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                           </td>
                        </tr>

                        <tr>
                          <td>Giấy chứng nhận đăng ký đầu tư</td>
                          <td>Giấy chứng nhận hiện hành</td>
                          <td>
                             <div className='file-pdf-upload'>
                            <di className='file-warper'>
                             <i className="fa-regular fa-file-pdf icon-pdff"></i>
                            gcn-dang-ky.pdf
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                           </td>
                        </tr>
                        {/* dòng 4 */}
                         <tr>
                          <td>Quy hoạch chi tiết 1/500</td>
                          <td>Bảo vệ quy hoạch</td>
                          <td>
                             <div className='file-pdf-upload'>
                            <di className='file-warper'>
                             <i className="fa-regular fa-file-pdf icon-pdff"></i>
                           quy-hoach-1-500.pdf
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                           </td>
                        </tr>
                        {/* dòng 5 */}
                         <tr>
                          <td>Đánh giá tác động môi trường</td>
                          <td>Báo cáo ĐTM đã được phê duyệt</td>
                          <td>
                             <div className='file-pdf-upload'>
                            <di className='file-warper'>
                             <i className="fa-regular fa-file-pdf icon-pdff"></i>
                           danh-gia-moi-truong.pdf
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                           </td>
                        </tr>
                        {/* dòng 6 */}
                          <tr>
                          <td>Hồ sơ khác (nếu có)</td>
                          <td>Các tài liệu liên quan khác</td>
                          <td>
                             <div className='file-pdf-upload'>
                            <di className='file-warper'>
                                <i class="fa-regular fa-file-zipper icon-zippp"></i>
                             {/* <i className="fa-regular fa-file-pdf icon-pdff"></i> */}
                           ho-so-khac.zip
                           </di>

                            <i className="fa-regular fa-trash-can icon-trashh"></i>
                           </div>
                           </td>
                        </tr>
                      </tbody>
                    </table>

                        {/* UPLOAD FILE */}
                    <div className="investment-upload-box">
                     
                        <div className="investment-upload-icon">
                        <i className="fa-solid fa-cloud-arrow-up "></i>
                      </div>

                      <p className="investment-upload-text">
                        Kéo thả file vào đây hoặc
                      </p>

                      <button className="investment-upload-btn">
                        Chọn file
                      </button>
                     

                     
                    </div>
                     <p className="investment-upload-format">
                        Định dạng: .pdf, .doc, .docx, .xls, .xlsx, .zip (Tối đa 50MB/file)
                      </p>

                    <div className="investment-warning-box">
                      <div className="investment-warning-title">
                        <i className="fa-solid fa-circle-info"></i>
                        Lưu ý
                      </div>

                      <p className="investment-warning-text">
                        Vui lòng đính kèm đầy đủ hồ sơ, tài liệu để hồ sơ được
                        tiếp nhận và xử lý nhanh chóng.
                      </p>

                      <p className="investment-warning-text">
                        Tổng dung lượng file tối đa: 200MB.
                      </p>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="investment-project-card">
                    <div className="investment-document-top">
                      <h3 className="investment-project-card-title">
                        Danh sách tài liệu đã tải lên
                      </h3>

                      <span className="investment-file-count">
                        <i className="fa-solid fa-check-double icon-share-show "></i>
                        7 file</span>
                    </div>

                    <div className="investment-success-box">
                      <i className="fa-solid fa-circle-check icon-upload-check"></i>

                      <div>
                        <p className="investment-success-title">
                          Đã tải lên 7/7 tài liệu bắt buộc
                        </p>

                        <p className="investment-success-text">
                          Bạn có thể xem trước hoặc tải file nếu cần.
                        </p>
                      </div>
                    </div>

                    <div className="investment-file-list">
                        {/* dòng 1 */}
                      <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf icon-check-repeat-again"></i>

                          <div>
                            <p className="investment-file-name">
                              de-nghi-du-an.pdf
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>

                        {/* dòng 2 */}
                      <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf icon-check-repeat-again"></i>

                          <div>
                            <p className="investment-file-name">
                              bao-cao-de-xuat.pdf
                            </p>

                            <span className="investment-file-size">
                              2.45 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>

                      {/* dòng 3 */}

                       <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf icon-check-repeat-again"></i>

                          <div>
                            <p className="investment-file-name">
                             qd-chu-truong.pdf
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>

                            {/* dòng 4 */}
                       <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf icon-check-repeat-again"></i>

                          <div>
                            <p className="investment-file-name">
                             gcn-dang-ky-dau-tu.pdf
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>

                        {/* Dòng 5 */}
                       <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf icon-check-repeat-again"></i>

                          <div>
                            <p className="investment-file-name">
                             quy-hoach-1-500.pdf
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>


                           {/* <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf"></i>

                          <div>
                            <p className="investment-file-name">
                              de-nghi-du-an.pdf
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div> */}
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>

                        {/* dòng 6 */}
                         <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-pdf icon-check-repeat-again"></i>

                          <div>
                            <p className="investment-file-name">
                              danh-gia-moi-truong.pdf
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>

                      {/* dòng 7 */}
                       <div className="investment-file-item">
                        <div className="investment-file-left">
                          <i className="fa-regular fa-file-zipper icon-zipper"></i>

                          <div>
                            <p className="investment-file-name">
                              ho-so-khac.zip
                            </p>

                            <span className="investment-file-size">
                              1.25 MB
                            </span>
                          </div>
                        </div>

                        <div className="investment-file-actions">
                          <i className="fa-regular fa-eye"></i>
                          <i className="fa-solid fa-download"></i>
                          <i className="fa-regular fa-trash-can"></i>
                        </div>
                      </div>
                    </div>

                    <div className="investment-project-form-group">
                      <label className="investment-project-label">
                        Ghi chú
                      </label>

                      <textarea
                        className="investment-project-textarea"
                        placeholder="Nhập nội dung ghi chú"
                      ></textarea>

                      <div className="investment-project-text-count">
                        0/1000
                      </div>
                    </div>
                  </div>
                </div>

                <div className="investment-project-footer">
                  <button
                    className="investment-project-back-btn"
                    onClick={prevIndustrialZoneStep}
                  >
                    <i className="fa-solid fa-arrow-left icon-share-show "></i>
                    Quay lại
                  </button>

                  <div className="investment-project-footer-right">
                    <button
                      className="investment-project-cancel-btn"
                      onClick={closeIndustrialZoneModal}
                    >
                      Hủy
                    </button>

                    <button className="investment-project-save-btn">
                      <i className="fa-regular fa-floppy-disk icon-share-show "></i>
                      Lưu tạm
                    </button>

                    <button className="investment-project-next-btn ">
                      Tiếp tục
                      <i className="fa-solid fa-arrow-right icon-next"></i>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
            </div>

    </div>
        );
    }

export default DauTu;